<div *ngIf="zone === 'onboarding'" class="col element-zoom m-0" [ngStyle]="contentStyle">
  <div
    class="widget-wrapper"
    [ngClass]="isStepComplete ? 'step-complete' : isError ? 'error' : 'open'"
    [ngStyle]="borderStyle"
    style="min-height: 100%"
  >
    <div *ngIf="widgetConfig.attributes['sub_heading']" class="title-wrapper">
      <div class="title">
        <p [ngStyle]="colorTextAlignStyle" class="subtitle">
          <span [innerHTML]="widgetConfig.attributes['sub_heading'] | safeHtml"></span>
        </p>
      </div>
      <div class="steps-count-wrapper">
        <span *ngIf="isStepComplete && !isError && isShowSuccessIcon" class="d-block">
          <img
            src="../../../../../../../../../assets/images/check-circle.svg"
            alt="check-circle"
            class="img-fluid"
          />
        </span>
        <span *ngIf="!isStepComplete && isError && isShowErrorIcon" class="d-block">
          <img
            (click)="showErrorMsg()"
            src="../../../../../../../../../assets/images/exclamation-circle.svg"
            alt="check-circle"
            class="cursor img-fluid"
          />
        </span>
      </div>
      <div *ngIf="!isStepComplete && isError && isShowErrorMsg" class="error-msg">
        <img
          src="../../../../../../../../../assets/images/exclamation-circle.svg"
          alt="check-circle"
          class="img-fluid"
        />
        <label>Phone number</label>
        <p>{{ errorMsg }}</p>
      </div>
    </div>
    <div class="form-wrapper">
      <form [formGroup]="phoneForm">
        <div class="form-group" *ngFor="let field of widgetConfig.attributes['field_attributes']">
          <ng-container *ngIf="field.type !== 'dropdown'">
            <label
              for="country_code"
              [ngStyle]="colorTextAlignStyle"
              *ngIf="!pageConfig?.labelsAsPlaceholder"
              >{{ field.label }}</label
            >
            <div class="p-inputgroup background-transparent position-relative">
              <finx-dropdown
                class="p-inputgroup-addon no-padding phoneDropdown"
                [ngClass]="{ 'pointer-events-none': isWorkflow }"
                formControlName="country_code"
                [options]="dialCodeOptions"
                [ngStyle]="countryCodeDropdownStyle"
                [textInputFontStyle]="textInputFontStyle"
                [style.width]="dropdownWidth"
                [style.height]="currentInputDropdownStyle?.['height']"
                appendto="body"
                [value]="phoneForm.get('country_code')?.value ?? ''"
                (focusEvent)="updateCurrentStyles($event, 'dropdown')"
                (valueChange)="checkCountryCodeValueChange()"
                panelStyleClass="phone-number-dropdown-panel"
              >
              </finx-dropdown>
              <finx-input
                type="text"
                [inputMode]="'decimal'"
                pInputText
                class="phoneNumber addon-left"
                formControlName="{{ field.name }}"
                [formGroup]="phoneForm"
                [(ngModel)]="phoneNumber"
                (change)="onChangePhoneInput()"
                [value]="phoneFormValue[field.name]"
                [textColor]="colorStyle"
                [labelAsPlaceholder]="pageConfig?.labelsAsPlaceholder"
                [textInputFontStyle]="textInputFontStyle"
                [textInputBackgroundColor]="textInputBackgroundColor"
                [inputStyle]="currentInputFieldStyle"
                (focusEvent)="updateCurrentStyles($event, 'input')"
                (valueChange)="phoneInputChange()"
                (keyup)="valueChangesTrigger()"
                [ngClass]="{ 'finx-input-with-padding': showConfirmBtn }"
              ></finx-input>
              <div class="verification-block">
                <finx-button
                  [buttonStyle]="!isAllowedGlobalStyling ? verifyButtonStyle : {}"
                  *ngIf="showConfirmBtn || isWorkflow"
                  type="button"
                  class="verify-button d-flex btn-small"
                  [ngClass]="{ 'pointer-events-none': isWorkflow }"
                  [class]="isAllowedGlobalStyling ? globalStylingClass : ''"
                  [labeltext]="verifyButtonTextContent ?? 'Verify'"
                  (click)="verifyPhoneNumber()"
                ></finx-button>
              </div>
            </div>
          </ng-container>
          <div
            class="text-error"
            *ngIf="phoneForm.get(field.name)?.touched && phoneForm.get(field.name)?.invalid"
          >
            <p class="m-0" *ngIf="!phoneString">
              {{ sanitizeFieldLabel(field.label) || 'Phone Number' }} is a required field
            </p>
            <p class="m-0" *ngIf="phoneString">
              Please enter a valid
              {{ sanitizeFieldLabel(field.label) || 'Phone Number' }}
            </p>
          </div>
        </div>
        @if (isPhoneVerificationEnabled && phoneForm.get('isPhoneVerified')?.invalid &&
        phoneForm.get('phone')?.valid) {
        <div class="text-error">
          <p class="m-0">Phone number needs validation before proceeding to the next step.</p>
        </div>
        }
        <div class="m-0 is-hidden" style="position: fixed; bottom: 1em; left: 1em; width: calc(100% - 2em)">
          <finx-button
            type="button"
            class="btn w-100 mt-2"
            labeltext="Confirm"
            (click)="onSubmit()"
          ></finx-button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- profile desgin  -->
<div
  *ngIf="zone === 'profile' || zone === 'verification' || dynamicZone"
  class="col element-zoom profile-page"
  [ngStyle]="combinedContentAndBorderStyles"
>
  <div class="form-wrapper">
    <form [formGroup]="phoneForm">
      <div class="form-group" *ngFor="let field of numberInputConfig">
        <label [ngStyle]="colorTextAlignStyle" for="phoneNumber" *ngIf="field.type !== 'dropdown'">{{
          field.label
        }}</label>
        <ng-container *ngIf="field.type !== 'dropdown'">
          <div class="p-inputgroup background-transparent position-relative">
            <finx-dropdown
              class="p-inputgroup-addon no-padding phoneDropdown"
              [ngClass]="{ 'pointer-events-none': isWorkflow }"
              formControlName="country_code"
              [options]="dialCodeOptions"
              [ngStyle]="countryCodeDropdownStyle"
              [textInputFontStyle]="countryDropdowntextInputFontStyle"
              [style.width]="dropdownWidth"
              appendto="body"
              [textColor]="colorStyle"
              [style.height]="currentInputDropdownStyle?.['height']"
              [value]="phoneForm.get('country_code')?.value ?? ''"
              panelStyleClass="phone-number-dropdown-panel"
              (valueChange)="checkCountryCodeValueChange()"
              (focusEvent)="updateCurrentStyles($event, 'dropdown')"
            >
            </finx-dropdown>
            <finx-input
              [textColor]="colorStyle"
              [readOnly]="isFieldDisabled"
              type="text"
              [inputMode]="'decimal'"
              pInputText
              className="phoneNumber no-increment-input addon-left"
              formControlName="{{ field.name }}"
              [formGroup]="phoneForm"
              [(ngModel)]="phoneNumber"
              (change)="verifiedPhoneChanged()"
              (keyup)="valueChangesTrigger()"
              [labelAsPlaceholder]="pageConfig?.labelsAsPlaceholder"
              [value]="phoneForm.get(field.name)?.value ?? ''"
              [textInputFontStyle]="textInputFontStyle"
              [textInputBackgroundColor]="textInputBackgroundColor"
              [inputStyle]="currentInputFieldStyle"
              (focusEvent)="updateCurrentStyles($event, 'input')"
              (valueChange)="phoneInputChange()"
              [ngClass]="{ 'finx-input-with-padding': showConfirmBtn }"
            ></finx-input>
            @if (isPhoneVerificationEnabled && (phoneForm.get('isPhoneVerified')?.invalid || isWorkflow)) {
            <div class="verification-block">
              <finx-button
                *ngIf="showConfirmBtn || isWorkflow"
                [buttonStyle]="!isAllowedGlobalStyling ? verifyButtonStyle : {}"
                type="button"
                class="verify-button d-flex btn-small"
                [ngClass]="{ 'pointer-events-none': isWorkflow }"
                [class]="isAllowedGlobalStyling ? globalStylingClass : ''"
                [labeltext]="verifyButtonTextContent ?? 'Verify'"
                (click)="verifyPhoneNumber()"
                (disabled)="(true)"
              ></finx-button>
              <span *ngIf="showWaitingIcon" class="d-block">
                <img
                  (click)="showErrorMsg()"
                  src="../../../../../../../../../assets/images/clock-blue.svg"
                  alt="check-circle"
                  class="cursor img-fluid"
                />
              </span>
            </div>
            }
          </div>

          <div
            class="text-error"
            *ngIf="phoneForm.get(field.name)?.touched && phoneForm.get(field.name)?.invalid"
          >
            <p *ngIf="!phoneNumber">{{ field.label }} is a required field</p>
            <p *ngIf="phoneNumber">Please Enter Valid {{ field.label }}!</p>
          </div>
          @if (isPhoneVerificationEnabled && phoneForm.get('isPhoneVerified')?.invalid &&
          phoneForm.get('phone')?.valid) {
          <div class="text-error">
            <p class="m-0">Phone number needs validation before proceeding to the next step.</p>
          </div>
          }
        </ng-container>
      </div>
    </form>
  </div>
</div>
